import convertBDTimeToLocal from "./../utils/convertBDTimeToLocal";
export default function WebinarSchedule() {
  const webinarSchedules = {
    webinar0: [
      { activity: "লাইভ ক্লাস + প্রশ্নোত্তর", day: "Thursday", time: "19:10" },
      {
        activity: "১০০ নাম্বারের mcq পরীক্ষা",
        day: "Saturday",
        time: "19:10",
      },
    ],
  };

  return (
    <section className="my-24">
      <div className="flex items-center">
        <span className="text-xl">ক্লাসের সময়ঃ </span>

        <span className="ml-3">
          আপনার স্থানীয় সময় ({Intl.DateTimeFormat().resolvedOptions().timeZone})
          অনুযায়ী
        </span>
      </div>
      <div className="my-10 py-10 bg-sky-200 rounded schedule_card">
        <div className="text-xl text-center my-10">
          <p className="">ওয়েবিনার - মুহসিন স্বামীর বৈশিষ্ট্য</p>
          {/* <p className=""> সপ্তাহে ১ দিন</p> */}
        </div>
        <div className="overflow-x-auto ">
          <table className="table  w-3/4 mx-auto text-xl ">
            <thead>
              <tr>
                <th></th>
                <th className="text-xl">
                  সময়
                  <span className="text-sm ml-3">
                    {Intl.DateTimeFormat()
                      .resolvedOptions()
                      .timeZone.split("/")[1]
                      .toUpperCase()}
                  </span>
                </th>
                <th className="text-xl">কার্যক্রম</th>
              </tr>
            </thead>
            <tbody>
              {webinarSchedules.webinar0.map((schedule, index) => (
                <tr key={schedule.day}>
                  <td>{index + 1}</td>
                  <td>{convertBDTimeToLocal(schedule.day, schedule.time)}</td>

                  <td>{schedule.activity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
